function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 26.8676,
  cy: 27.519,
  r: 26.8676,
  fill: "#C7D14C"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M22.7598 28.1343H26.3118V34.9503C25.3998 35.6383 24.3438 36.1663 23.1438 36.5343C21.9438 36.9023 20.7358 37.0863 19.5198 37.0863C17.7758 37.0863 16.2078 36.7183 14.8158 35.9823C13.4238 35.2303 12.3278 34.1983 11.5278 32.8863C10.7438 31.5583 10.3518 30.0623 10.3518 28.3983C10.3518 26.7343 10.7438 25.2463 11.5278 23.9343C12.3278 22.6063 13.4318 21.5743 14.8398 20.8383C16.2478 20.0863 17.8318 19.7103 19.5918 19.7103C21.0638 19.7103 22.3998 19.9583 23.5998 20.4543C24.7998 20.9503 25.8078 21.6703 26.6238 22.6143L24.1278 24.9183C22.9278 23.6543 21.4798 23.0223 19.7838 23.0223C18.7118 23.0223 17.7598 23.2463 16.9278 23.6943C16.0958 24.1423 15.4478 24.7743 14.9838 25.5903C14.5198 26.4063 14.2878 27.3423 14.2878 28.3983C14.2878 29.4383 14.5198 30.3663 14.9838 31.1823C15.4478 31.9983 16.0878 32.6383 16.9038 33.1023C17.7358 33.5503 18.6798 33.7743 19.7358 33.7743C20.8558 33.7743 21.8638 33.5343 22.7598 33.0543V28.1343ZM33.8114 23.1183V27.5583H41.5874V30.6783H33.8114V36.7983H29.9234V19.9983H42.6194V23.1183H33.8114Z",
  fill: "white"
});

function SvgGlutenFree(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 55,
    viewBox: "0 0 54 55",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlutenFree);
export default __webpack_public_path__ + "static/media/gluten-free.421cfb3d.svg";
export { ForwardRef as ReactComponent };